import React, { useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import IntlMessages from "@util/IntlMessages";
import { Message, Switch, Button, Spin, Input, Checkbox } from "../../../BP2Components";
import { KanbanScripts } from "../../DefaultWidgets/KanbanWidget/KanbanScripts";
import {
   Icon_ArrowDown,
   Icon_ArrowLeft,
   Icon_ArrowRight,
   Icon_ArrowUp,
} from "../../../BP2Components/Icons/icons";
import "./kanbanSettings.less";
import "../AdvertisementList/advertisementListSettings.less";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";

const { Option } = Select;

const { validColumnsForHorizontalPlacement } = KanbanScripts;

export const filterColumns = (columns, rows) => {
   return columns.filter(({ title }) => {
      let isValid = true;
      rows.forEach((row) => {
         if (
            row[title] instanceof Array ||
            (typeof row[title] === "object" && row[title] && !row[title].value)
         )
            isValid = false;
      });
      return isValid;
   });
};

const KanbanSettings = ({ value, columns, rows, loading }) => {
   const dispatch = useDispatch();
   const intl = useIntl();
   const [settings, setSettings] = useState({
      ...value,
   });
   const [listId, setlistId] = useState(value.listId);

   const handleSubmit = (e) => {
      const defaultSettings = {
         ...settings,
         itemContent: [],
         horizontalPlacement: null,
         verticalPlacement: null,
         groupItems: true,
         sortRows: true,
         sortColumnsByName: true,
         // autoSave: true
      };
      e.preventDefault();
      if (listId == settings.listId) {
         dispatch(setWidgetInSheetParams(settings));
      } else {
         dispatch(setWidgetInSheetParams(defaultSettings));
         setlistId(settings.listId);
         setSettings(defaultSettings);
      }
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const isDefaultValueValid = (value, columns) => {
      return !!columns.find(({ techName }) => techName === value);
   };

   const SelectColumn = ({ item, columns }) => (
      <div className="selectColumn">
         <Select
            value={isDefaultValueValid(settings[item], columns) ? settings[item] : "-"}
            defaultValue={settings[item]}
            onChange={(e) => handleChange(e, item)}
         >
            <Option value={"-"}>-</Option>
            {columns.map(({ title, techName }, i) => (
               <Option value={techName} key={i}>
                  {title}
               </Option>
            ))}
         </Select>
      </div>
   );

   const handleChange = (value, name) => {
      setSettings({ ...settings, [name]: value === "-" ? null : value });
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   return (
      <>
         <form onSubmit={handleSubmit} className="kanban-settings-container">
            <div className="widget-settings">
               <div key="globalSettings" className="widget-settings__inner">
                  <label key="listId" className="widget-settings__inner__label">
                     <IntlMessages id="settings.listId" />:
                     <Input
                        onChange={(e) => handleChange(e.target.value, "listId")}
                        defaultValue={settings.listId}
                        name="listId"
                        id="listId"
                     ></Input>
                  </label>
                  <label key="exportXLS" className="widget-settings__inner__label">
                     <IntlMessages id="settings.exportXLS" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "exportXLS")}
                        defaultChecked={settings?.exportXLS}
                        name="exportXLS"
                        id="exportXLS"
                     />
                  </label>
                  <label key="sumNumberOfRowsInColumn" className="widget-settings__inner__label">
                     <IntlMessages id="settings.sumNumberOfRowsInColumn" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "sumNumberOfRowsInColumn")}
                        defaultChecked={settings?.sumNumberOfRowsInColumn}
                        name="sumNumberOfRowsInColumn"
                        id="sumNumberOfRowsInColumn"
                     />
                  </label>
                  <label key="horizontalPlacement" className="widget-settings__inner__label">
                     <IntlMessages id="settings.horizontalPlacement" />:
                     <SelectColumn
                        item="horizontalPlacement"
                        columns={validColumnsForHorizontalPlacement(columns)}
                     />
                  </label>
                  <label key="sortColumns" className="widget-settings__inner__label">
                     <IntlMessages id="settings.sortColumns" />:
                     <Checkbox
                        onChange={(e) => handleSwitch(e.target.checked, "sortColumns")}
                        defaultChecked={settings.sortColumns}
                     />
                  </label>
                  <label className="widget-settings__inner__label">
                     <IntlMessages id="settings.sortColumnsByName" />:
                     <Switch
                        onChange={(e) => handleChange(e, "sortColumnsByName")}
                        defaultChecked={settings.sortColumnsByName}
                        className="switch-position"
                     />
                  </label>
                  <label key="verticalPlacement" className="widget-settings__inner__label">
                     <IntlMessages id="settings.verticalPlacement" />:
                     <SelectColumn
                        item="verticalPlacement"
                        columns={filterColumns(columns, rows)}
                     />
                  </label>
                  <label id="sortRows" key="sortRows" className="widget-settings__inner__label">
                     <IntlMessages id="settings.sortRows" />:
                     <Checkbox
                        onChange={(e) => handleSwitch(e.target.checked, "sortRows")}
                        defaultChecked={settings.sortRows}
                     />
                  </label>
                  <label
                     id="blockHorizontalMovement"
                     key="blockHorizontalMovement"
                     className="widget-settings__inner__label"
                  >
                     <IntlMessages id="settings.blockHorizontalMovement" />:
                     <Checkbox
                        defaultChecked={settings.blockHorizontalMovement}
                        onChange={(e) => handleChange(e.target.checked, "blockHorizontalMovement")}
                     ></Checkbox>
                  </label>
                  <label
                     id="blockVerticalMovement"
                     key="blockVerticalMovement"
                     className="widget-settings__inner__label"
                  >
                     <IntlMessages id="settings.blockVerticalMovement" />:
                     <Checkbox
                        defaultChecked={settings.blockVerticalMovement}
                        onChange={(e) => handleChange(e.target.checked, "blockVerticalMovement")}
                     ></Checkbox>
                  </label>

                  <label key="showSortColumns" className="widget-settings__inner__label">
                     <IntlMessages id="settings.showSortColumns" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "showSortColumns")}
                        defaultChecked={settings?.showSortColumns}
                        name="showSortColumns"
                        id="showSortColumns"
                     />
                  </label>

                  <label key="showSortRows" className="widget-settings__inner__label">
                     <IntlMessages id="settings.showSortRows" />:
                     <Switch
                        onChange={(e) => handleSwitch(e, "showSortRows")}
                        defaultChecked={settings?.showSortRows}
                        name="showSortRows"
                        id="showSortRows"
                     />
                  </label>

                  {/* we can use this buttons, if we save widget cache settings on backend*/}

                  {/* <label className="widget-settings__inner__label">
                     <IntlMessages id="szerokość kolumn" />:
                     <Button onClick={saveColumnSize}>zapisz</Button>

                     <Button
                     buttonType="primary"   
                     disabled={
                           eval(localStorage.getItem("kanbanCache"))?.find(
                              (widget) => widget.widgetId === value?.id
                           ) === undefined
                              ? true
                              : false
                        }
                     >
                        przywróć domyśle
                     </Button>
                  </label> */}
               </div>
               {loading ? (
                  <div className="kanban-settings-loader">
                     <Spin />
                  </div>
               ) : null}
               <Button
                  key="btn"
                  buttonType="primary"
                  htmlType="submit"
                  className="kanban-settings-save"
               >
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default KanbanSettings;
